export default __webpack_public_path__ + "static/media/TasFirstScreen.e1cc5ed3.gif";